import { HttpContext, HttpContextToken } from '@angular/common/http';

/**
 * When true on a request's HttpContext, HtmlDecodeInterceptor leaves the response body
 * escaped. Set it on endpoints whose data feeds an `[innerHTML] | safe` sink until that
 * sink is remediated (see spec Phase 2).
 */
export const SKIP_HTML_DECODE = new HttpContextToken<boolean>(() => false);

/** Convenience for request options: `{ context: withSkipHtmlDecode() }`. */
export function withSkipHtmlDecode(context: HttpContext = new HttpContext()): HttpContext {
    return context.set(SKIP_HTML_DECODE, true);
}
